import classnames from "classnames";
import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

// reactstrap components
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { IModalActionButton } from "../../app/models/dto";
import { RootStoreContext } from "../../app/stores/rootStore";

interface IProps {
  title?: string;
  isOpen: boolean;
  size?: string;
  toggle: (successfullyCompleted? : boolean) => void;
  content: JSX.Element | string;
  actions?: IModalActionButton[];
  cancelBtn?: boolean;
  modalBodyClassname?: string;
  modalClassname?:string;
  isMobile?: boolean;  
  modalHeaderClass?: string;
}

const GenericModal: React.FC<IProps> = ({
  isOpen,
  toggle,
  title,
  size,
  content,
  actions,
  cancelBtn,
  modalBodyClassname,
  modalClassname,
  isMobile,
  modalHeaderClass
}) => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const [t] = useTranslation(["translation"], translationHookOptions);

  const handleClick = (action: IModalActionButton) => {
    action.action();
    toggle(true);
  };
  const toggleModal = () => {
    toggle();
  };

  return (
    <Modal isOpen={isOpen} size={size ? size : "lg"} toggle={toggleModal} className={modalClassname}>
      {title && <ModalHeader   
       className={classnames(`${theme!.headerModal} ${theme!.headerTextColor} ${modalHeaderClass} genericModalHeader`)}
       close={<button className="closeModalIcon" onClick={() =>{toggleModal()}}><i className="far fa-times-circle fa-lg"></i></button>}
       cssModule={{'modal-title': (isMobile? 'modal-custom-title' : 'modal-title')}}
    toggle={toggleModal}>{title}</ModalHeader>}
      <ModalBody className={modalBodyClassname}>{content}</ModalBody>
      {cancelBtn || (actions && actions.length > 0) ? (
        <ModalFooter>
          {actions &&
            actions.map((act, i) => (
              <Button
              className={classNames( "genericButtonClassic",
              act.color ? `${theme!.buttonSecondaryColor} ${theme!.buttonSecondaryBorderColor} ${theme!.buttonSecondaryTextColor}` : `${theme!.buttonColor} ${theme!.buttonBorderColor} ${theme!.buttonTextColor}`)}
                key={i}
                // color={act.color ? act.color : theme!.buttonColor}
                onClick={() => handleClick(act)}
              >
                {act.text}
              </Button>
            ))}

          {cancelBtn && (
            <Button className={classNames(
              `${theme!.buttonSecondaryColor} ${theme!.buttonSecondaryBorderColor} ${theme!.buttonSecondaryTextColor}`)} onClick={toggleModal}>
              {t("cancel")}
            </Button>
          )}
        </ModalFooter>
      ) : (
        <></>
      )}
    </Modal>
  );
};

export default observer(GenericModal);
